/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Theme_DarkInputs */

const en_settings_theme_dark = /** @type {(inputs: Settings_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark`)
};

const he_settings_theme_dark = /** @type {(inputs: Settings_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כהה`)
};

/**
* | output |
* | --- |
* | "Dark" |
*
* @param {Settings_Theme_DarkInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_theme_dark = /** @type {((inputs?: Settings_Theme_DarkInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_DarkInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_theme_dark(inputs)
	return he_settings_theme_dark(inputs)
});